import * as t from 'modules/queryBuilder/legacyQueryBuilder/actionTypes';
import { COLLECTION } from 'modules/catalog/actionTypePrefixes';

/** Creating aliases for catalog query builder. */
const {
  CHANGE_COMBINATOR,
  CHANGE_QUERY_ORDER_BY,
  CHANGE_QUERY_SIZE_LIMIT,
  SET_USES_SMART_RECOS,
  UPDATE_QUERY: QUERY_HAS_CHANGED,
  UPDATE_QUERY_FROM_STATE: QUERY_HAS_CHANGED_FROM_STATE,
} = t;
export {
  CHANGE_COMBINATOR,
  CHANGE_QUERY_ORDER_BY,
  CHANGE_QUERY_SIZE_LIMIT,
  SET_USES_SMART_RECOS,
  QUERY_HAS_CHANGED,
  QUERY_HAS_CHANGED_FROM_STATE,
};

export const CHANGE_CURRENT_FIELDS = `${COLLECTION}/CHANGE_CURRENT_FIELDS`;

export const FETCH_COLLECTION = `${COLLECTION}/FETCH_COLLECTION`;
export const FETCH_COLLECTION_ERROR = `${FETCH_COLLECTION}_ERROR`;
export const FETCH_COLLECTION_RESPONSE = `${FETCH_COLLECTION}_RESPONSE`;

export const FETCH_FIELD_MAPPING_REQUEST = `${COLLECTION}/FETCH_FIELD_MAPPINGS_REQUEST`;
export const FETCH_FIELD_MAPPING_RESPONSE = `${COLLECTION}/FETCH_FIELD_MAPPINGS_RESPONSE`;
export const FETCH_FIELD_MAPPING_ERROR = `${COLLECTION}/FETCH_FIELD_MAPPINGS_ERROR`;

/** Base Catalog Collection Actions */
export const CHANGE_CATALOG = `${COLLECTION}/CHANGE_CATALOG`;
export const CHANGE_COLLECTION_DESCRIPTION = `${COLLECTION}/CHANGE_COLLECTION_DESCRIPTION`;
export const CHANGE_COLLECTION_DETAILS = `${COLLECTION}/CHANGE_COLLECTION_DETAILS`;
export const CHANGE_COLLECTION_NAME = `${COLLECTION}/CHANGE_COLLECTION_NAME`;
export const RESET_COLLECTION_BUILDER = `${COLLECTION}/RESET_COLLECTION_BUILDER`;

/** Create Catalog Query Name Actions */
export const CREATE_COLLECTION = `${COLLECTION}/CREATE_COLLECTION`;
export const CREATE_COLLECTION_ERROR = `${CREATE_COLLECTION}_ERROR`;
export const CREATE_COLLECTION_RESPONSE = `${CREATE_COLLECTION}_RESPONSE`;

/** Update Catalog Query Name Actions */
export const UPDATE_COLLECTION = `${COLLECTION}/UPDATE_COLLECTION`;
export const UPDATE_COLLECTION_ERROR = `${UPDATE_COLLECTION}_ERROR`;
export const UPDATE_COLLECTION_RESPONSE = `${UPDATE_COLLECTION}_RESPONSE`;

/** Preview Catalog Collections Actions */
export const PREVIEW_COLLECTION = `${COLLECTION}/PREVIEW_COLLECTION`;
export const PREVIEW_COLLECTION_ERROR = `${PREVIEW_COLLECTION}_ERROR`;
export const PREVIEW_COLLECTION_RESPONSE = `${PREVIEW_COLLECTION}_RESPONSE`;
